<template>
  <div>
    <div
      id="echarts"
      ref="echarts"
      style="width: 680px; height: 200px"
    ></div>
    <el-table
      :data="data"
      border
      max-height="260"
      style="font-size: 12px; width: 100%"
    >
      <el-table-column
        property="date"
        label="日期"
        width="90"
      ></el-table-column>
      <el-table-column
        property="validSaleOrderCount"
        label="加购数量"
      >
        <template slot-scope="scope"> {{ scope.row.addPayCount }} </template>
      </el-table-column>
      <el-table-column
        property="ds"
        label="加购成本"
      >
        <template slot-scope="scope">
          {{ scope.row.addPayCost }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    level: String,
    data: Object,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    drawEcharts() {
      var chartDom = this.$refs.echarts;
      if (!chartDom) return;
      var myChart = this.$echarts.init(chartDom);

      var option;
      option = {
        title: {
          // text: "订单量展示",
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['加购数量', '加购成本'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.data.map((v) => v.date),
          axisLabel: {
            // rotate: 30,
            fontSize: 10,
          },
        },
        yAxis: [
          { type: 'value', name: '加购数量' },
          { type: 'value', name: '加购成本', alignTicks: true },
        ],
        series: [
          {
            name: '加购数量',
            type: 'line',
            // stack: "总量",
            data: this.data.map((v) => v.addPayCount),
          },
          {
            name: '加购成本',
            type: 'line',
            yAxisIndex: 1,
            // stack: "总量",
            data: this.data.map((v) => v.addPayCost),
          },
        ],
      };
      myChart.setOption(option);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.drawEcharts();
          });
        }
      },
    },
  },
};
</script>
